import React, { useState } from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";

interface CrossIconProps extends SvgIconProps {}

const CrossIcon = ({ hovered = false, ...props }: CrossIconProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 21 21">
      {hovered ? (
        <svg
          width="21"
          height="21"
          viewBox="0 0 21 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="10.5" cy="10.5" r="9.5" fill="#E8F1FB" />
          <path
            d="M13.6666 7.33325L7.33325 13.6666"
            stroke="#1976D2"
            stroke-width="1.2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M7.33325 7.33325L13.6666 13.6666"
            stroke="#1976D2"
            stroke-width="1.2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M10.5 20C15.7467 20 20 15.7467 20 10.5C20 5.25329 15.7467 1 10.5 1C5.25329 1 1 5.25329 1 10.5C1 15.7467 5.25329 20 10.5 20Z"
            stroke="#1976D2"
            stroke-width="1.2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      ) : (
        <svg
          width="21"
          height="21"
          viewBox="0 0 21 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.6666 7.33325L7.33325 13.6666"
            stroke="#1976D2"
            stroke-width="1.2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M7.33325 7.33325L13.6666 13.6666"
            stroke="#1976D2"
            stroke-width="1.2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M10.5 20C15.7467 20 20 15.7467 20 10.5C20 5.25329 15.7467 1 10.5 1C5.25329 1 1 5.25329 1 10.5C1 15.7467 5.25329 20 10.5 20Z"
            stroke="#1976D2"
            stroke-width="1.2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      )}
    </SvgIcon>
  );
};

export default CrossIcon;
